import * as React from "react";
import $ from "jquery";
import {
  updateFormConfigs,
  updateQuestionSetting,
  updateThemeConfig,
} from "../actions";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import {
  Button,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  makeStyles,
  Slider,
  Switch,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { connect, useDispatch } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import TranslateIcon from "@mui/icons-material/Translate";
import ListIcon from "@mui/icons-material/List";
import SettingsIcon from "@mui/icons-material/Settings";
import { Divider, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { LoadingButton } from "@mui/lab";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles((props) => ({
  header: {
    color: "var(--accent-color)",
    backgroundColor: "var(--primary-color)",
    height: "fit-content",
    minHeight: "60px",
    alignItems: "center",
    marginBottom: "50px",
    position: "relative",
  },
  text: {
    "& .MuiInputBase-root input": {
      fontFamily: "var(--font-family)",
      color: "var(--accent-color)",
      borderBottom: "unset",
      fontSize: "var(--font-size)",
      lineHeight: "var(--font-size)",
      textAlign: "center",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "unset",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "unset",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "unset",
    },
  },
  headerButton: {
    display: "flex",
    alignItem: "center",
    justifyContent: "end",
    paddingRight: "10px",
  },
  settingButton: {
    position: "absolute",
    right: "-20px",
    top: "-20px",
  },
}));

function FormHeader(props) {
  const [title, setTitle] = React.useState("");
  const classes = useStyles();
  return (
    <Grid
      container
      classes={{ root: classes.header }}
      px={2}
      style={{
        backgroundColor:
          props.hide_header == "0" ? "unset" : "var(--primary-color)",
      }}
    >
      <Grid item xs={3}>
        <LogoForm {...props} />
      </Grid>
      {props.previewForm && !props.displaytitle["label::" + props.language] ? (
        <Grid item xs={6}></Grid>
      ) : props.hide_header != "0" ? (
        <Grid item xs={6}>
          {props.appearance_relevant && (
            <FormTitle {...props} setTitle={setTitle} />
          )}
        </Grid>
      ) : (
        <Grid item xs={6}></Grid>
      )}

      <Grid item xs={3} classes={{ root: classes.headerButton }}>
        {props.jump_to == "1" && (
          <IconButton
            style={{
              color: "var(--accent-color)",
              backgroundColor: "var(--primary-color)",
              margin: "5px",
            }}
            size="small"
          >
            <ListIcon fontSize="small" />
          </IconButton>
        )}

        {props.save_mid == "1" && (
          <IconButton
            style={{
              color: "var(--accent-color)",
              backgroundColor: "var(--primary-color)",
              margin: "5px",
            }}
            size="small"
          >
            <SaveIcon fontSize="small" />
          </IconButton>
        )}

        {props.change_language == "1" && (
          <IconButton
            style={{
              color: "var(--accent-color)",
              backgroundColor: "var(--primary-color)",
              margin: "5px",
            }}
            size="small"
          >
            <TranslateIcon fontSize="small" />
          </IconButton>
        )}
      </Grid>
      {!props.previewForm && <HeaderSetting {...props} />}
    </Grid>
  );
}

const mapStateToProps = (state, props) => {
  return {
    form_configs: state.form_configs,
    change_language: state.form_configs.change_language,
    save_mid: state.form_configs.save_mid,
    jump_to: state.form_configs.jump_to,
    hide_header: state.theme_config.hide_header,
    displaytitle: state.questionsList.displaytitle,
    appearance_title: state.questionsList.displaytitle.appearance,
    appearance_relevant: state.questionsList.displaytitle.relevant,
    language: state.form_settings.default_language,
    logo: state.theme_config.logo,
    logo_size: state.theme_config.logo_size,
    previewForm: state.previewForm,
  };
};
export default connect(mapStateToProps)(FormHeader);

function FormTitle({ ...props }) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const dispatch = useDispatch();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const classes = useStyles();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <TextField
        classes={{ root: classes.text }}
        value={props.displaytitle["label::" + props.language] || ''}
        fullWidth
        placeholder="Enter form title"
        onClick={handleClickOpen}
      />
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle>{"Form title"}</DialogTitle>
        <DialogContent>
          <FormGroup
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {Object.keys(props.displaytitle).map((label) => {
              if (label.indexOf("label::") > -1) {
                return (
                  <TextField
                    key={"displaytitle" + label}
                    value={props.displaytitle[label] || ''}
                    onChange={(e) => {
                      dispatch(
                        updateQuestionSetting(
                          "displaytitle",
                          label,
                          e.target.value
                        )
                      );
                      props.setTitle(e.target.value);
                    }}
                    label={label}
                    variant="standard"
                    fullWidth
                  />
                );
              }
              return [];
            })}
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function HeaderSetting({ ...props }) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const dispatch = useDispatch();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const classes = useStyles();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <IconButton
        color="primary"
        // size="large"
        className={classes.settingButton}
        onClick={handleClickOpen}
      >
        <SettingsIcon />
      </IconButton>
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle>{"Header Setting"}</DialogTitle>
        <DialogContent>
          <FormGroup>
            <Typography py={2}>Button control</Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={props.change_language == "1"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      dispatch(updateFormConfigs("change_language", "1"));
                    } else {
                      dispatch(updateFormConfigs("change_language", "0"));
                    }
                  }}
                />
              }
              label="Change language button"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={props.save_mid == "1"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      dispatch(updateFormConfigs("save_mid", "1"));
                    } else {
                      dispatch(updateFormConfigs("save_mid", "0"));
                    }
                  }}
                />
              }
              label="Save mid button"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={props.jump_to == "1"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      dispatch(updateFormConfigs("jump_to", "1"));
                    } else {
                      dispatch(updateFormConfigs("jump_to", "0"));
                    }
                  }}
                />
              }
              label="Table of contents (TOC) button"
            />
          </FormGroup>
          <Divider />
          <Typography py={2}>Header settings</Typography>
          <FormGroup
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <TextField
              style={{ flexGrow: 1 }}
              defaultValue={props.hide_header}
              value={props.hide_header}
              onChange={(e) => {
                dispatch(updateThemeConfig("hide_header", e.target.value));
              }}
              label="Hide header bar"
              variant="standard"
              type="number"
            />
            <Tooltip title="Time to hide header (default 5s), -1 is always show, 0 is hide.">
              <Typography>{"(?)"}</Typography>
            </Tooltip>
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={props.appearance_relevant}
                  onChange={(e) => {
                    if (e.target.checked) {
                      dispatch(
                        updateQuestionSetting("displaytitle", "relevant", true)
                      );
                    } else {
                      dispatch(
                        updateQuestionSetting("displaytitle", "relevant",false)
                      );
                    }
                  }}
                />
              }
              label="Show title form"
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function LogoForm({ ...props }) {
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const dispatch = useDispatch();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const classes = useStyles();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      {props.logo?.length == 0 && !props.previewForm && (
        <Tooltip title="Add logo">
          <IconButton
            style={{
              color: "var(--accent-color)",
              backgroundColor: "var(--primary-color)",
              margin: "5px",
            }}
            size="small"
            onClick={handleClickOpen}
          >
            <AddCircleOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {props.logo?.length > 0 && (
        <div
          className="kt-portlet__head-label"
          style={{ padding: "5px 10px", position: "relative" }}
          onMouseOver={() => {
            $(`.setting_logo_btn`).css("opacity", "1");
          }}
          onMouseOut={() => {
            $(`.setting_logo_btn`).css("opacity", "0");
          }}
        >
          <img
            onClick={!props.previewForm && handleClickOpen}
            src={props.logo}
            className="btn btn-icon"
            style={{ width: "auto", height: props.logo_size + "px" }}
          />
          {!props.previewForm && (
            <>
              <lable
                className="m-0 dlt_choice_btn setting_logo_btn"
                onClick={(e) => {
                  dispatch(updateThemeConfig("logo", ""));
                  dispatch(updateThemeConfig("logo_size", 50));
                  e.preventDefault();
                  e.stopPropagation();
                }}
                style={{
                  top: "0",
                  left: "0",
                  color: "#000",
                  right: "unset",
                  cursor: "pointer",
                }}
              >
                <CloseIcon fontSize="small" />
              </lable>

              <div
                className="form-group m-0 setting_logo_btn"
                style={{ position: "absolute", left: "0", right: "0" }}
              >
                <Slider
                  name="logo_size"
                  onChange={(event, newValue) => {
                    dispatch(updateThemeConfig("logo_size", newValue));
                  }}
                  defaultValue={props.logo_size}
                  valueLabelDisplay="auto"
                  max={100}
                  min={0}
                  step={1}
                  color="secondary"
                />
              </div>
            </>
          )}
        </div>
      )}
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle>{"Add logo"}</DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={value} onChange={handleChange}>
                <Tab label="Upload" {...a11yProps(0)} />
                <Tab label="Search" {...a11yProps(1)} />
                <Tab label="Custom" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0} style={{ textAlign: "center" }}>
              <LoadingButton
                color="primary"
                loading={loading}
                loadingPosition="start"
                startIcon={<FileUploadIcon />}
                variant="contained"
              >
                Upload File
                <input
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "0",
                    bottom: "0",
                    right: "0",
                    left: "0",
                    width: "100%",
                    opacity: "0",
                  }}
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    setLoading(true);
                    handleUploadImageToS3(e.target.files[0])
                      .then(function (result) {
                        setLoading(false);
                        dispatch(
                          updateThemeConfig("logo", result.files[0].public_url)
                        );
                      })
                      .catch(function () {
                        // An error occurred
                      });
                  }}
                />
              </LoadingButton>
              <div style={{ width: "100%", height: "100px", padding: "10px" }}>
                <img src={props.logo} style={{ width: "100%" }} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
              Not support now!
            </TabPanel>
            <TabPanel value={value} index={2}>
              Not support now!
            </TabPanel>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function handleUploadImageToS3(file = null) {
  let fileName = Date.now().toString();
  let postData =
    '{"data":{"' +
    fileName +
    '_ExtraArgs":"{\\"ACL\\": \\"public-read-write\\"}","' +
    fileName +
    '_FileMeta":"{\\"project_code\\":\\"C026\\",\\"resource_type\\":\\"local.test.screenshot\\"}"},"files":{"' +
    fileName +
    '":"__file__"}}';
  postData = JSON.parse(postData);
  let ajaxData = {
    type: "POST",
    url: "https://storage.rta.vn/s3/upload",
    contentType: false,
    processData: false,
    // success: (res, status, xhr) => {
    //   return res.files[0].public_url
    // },
    // error: (xhr, status, error) => {
    //   return ''
    // },
    xhr: () => {
      let jqXHR = new XMLHttpRequest();
      jqXHR.withCredentials = false;
      jqXHR.open("POST", "https://storage.rta.vn/s3/upload");
      return jqXHR;
    },
    timeout: 10000,
  };

  let formData = new FormData();
  Object.keys(postData.data).map((keyName) =>
    formData.append(keyName, postData.data[keyName])
  );
  if (file) {
    Object.keys(postData.files).map((keyName) =>
      formData.append(keyName, file)
    );
  }
  ajaxData["data"] = formData;
  return $.ajax(ajaxData);
}
